import React, { useState } from 'react'
//Bibliotecas
import { useForm } from 'react-hook-form';
import { useParams, NavLink, useNavigate, useLocation } from 'react-router-dom';
//Componentes
import Form from '../components/common/Form';
import Input from '../components/common/Input';
import Button, { SecondaryButton } from '../components/common/Button';
import Error from '../components/common/Error';
import FlexContainer from '../components/common/FlexContainer';
//Servicios
import AuthService from '../services/AuthService';
//Imágenes
import { ArrowRight, LogIn } from 'react-feather';

export default function ResetPassword() {
    //Estados
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    //React Hook Form
    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    //URL Params
    let { _id } = useParams();

    //Manejar el envío del formulario
    const onSubmit = (data) => {
        if (data.password !== data.confirmPassword) {
            setError('Las contraseñas no coinciden')
        } else {
            setError('');
            AuthService.resetPassword(data, _id).then((res) => {
                setSuccess(true);
            }).catch((error) => setError(error.message));
        }
    }

    //Navigate
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from.pathname || "/home";

    if (success) {
        return (
            <FlexContainer margin='2% 5%' width='35%' padding='32px 40px' borderRadius='10px' justifyContent='center'>
                <h1>Restablecimiento completo</h1>
                <h4>
                    Felicidades tu contraseña se ha restablecido exitosamente ✅
                </h4>
                <Button type='submit' margin='16px 0px' onClick={() => navigate(from,{replace:true})}><LogIn />Iniciar sesión</Button>
            </FlexContainer>
        )
    }

    return (
        <Form title='Restablecer contraseña' onSubmit={handleSubmit(onSubmit)}>
            <Input
                label='Nueva contraseña'
                name='password'
                type='password'
                placeholder="Ingresa tu nueva contraseña"
                register={register}
                required={{ required: "Por favor ingresa la nueva contraseña", minLength: { value: 5, message: "La contraseña debe tener más de 5 caracteres" } }}
                error={errors.password} />
            <Input
                label='Confirmar contraseña'
                name='confirmPassword'
                type='password'
                placeholder="Confirma tu nueva contraseña"
                register={register}
                required={{ required: "Por favor confirma la nueva contraseña" }}
                error={errors.confirmPassword} />

            <Button type='submit'>Confirmar <ArrowRight /></Button>
            <Error message={error}></Error>
        </Form>
    )
}
